import { HistoryRouter } from "redux-first-history/rr6";
import { store, history } from "./store";
import { Provider } from "react-redux";
import { ThemeProvider } from "@mui/material";
import ReactDOM from "react-dom/client";
import reportWebVitals from "./reportWebVitals";
import "./assets/css/global.css";
import "./assets/css/typeform.css";
import { theme } from "./theme";
import Screens from "./screens";
import { CookiesProvider } from "react-cookie";
import { LastLocationProvider } from "react-router-dom-last-location";
import { QueryClientProvider } from "@tanstack/react-query";
import "animate.css/animate.css";
import "./assets/css/marketplace.css";
import { queryClient } from "./query-client";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <ThemeProvider theme={theme}>
    <Provider store={store}>
      <HistoryRouter history={history}>
        <LastLocationProvider>
          <CookiesProvider>
            <QueryClientProvider client={queryClient}>
              <Screens />
            </QueryClientProvider>
          </CookiesProvider>
        </LastLocationProvider>
      </HistoryRouter>
    </Provider>
  </ThemeProvider>
);

reportWebVitals();
